import debounce from 'lodash-es/debounce';
import { Middleware } from 'redux';
import state from './state';

const debounceTime = 100;

const shouldBatch = (action: { meta?: { batch?: unknown } }) =>
  !!(action.meta && action.meta.batch);

const middleware: Middleware = () => (next) => (action) => {
  const resolved = next(action);
  if (!state.notify) return resolved;

  const notify = shouldBatch(action) ? debounce(state.notify, debounceTime) : state.notify;

  notify();

  return resolved;
};

export default middleware;
